<template>
  <Content id="errorReportList" :style="{'margin-left': '10px','max-height':tableHeight}">
    <div slot="search">
      <Form :label-width="45" :model="form" id="searchForm">
        <Row>
          <Col><FormItem label="名称"><el-input v-model="form.name" :maxlength="100" :clearable="true"/></FormItem></Col>
          <Col><FormItem label="条形码" :label-width="60"><el-input v-model="form.barCode" :maxlength="13" :clearable="true" @input="toInt()"/></FormItem></Col>
          <Col><FormItem label="手机号码" :label-width="75"><el-input v-model="form.phone" :maxlength="11" :clearable="true" @input="pareInt('phone')" style="width: 100%;"/></FormItem></Col>
          <Col><div style="display:flex;">&nbsp;&nbsp;<Button type="primary" @click="search">查询</Button></div></Col>
        </Row>
      </Form>
    </div>

    <el-table :data="dataList" ref="singleTable" style="width: 100%;" :header-cell-style="{ background:'#f8f8f9',color:'#515a6e','text-align':'center'}"
              :row-class-name="tableRowClassName" @row-click="selectrow" highlight-current-row highlight-selection-row row-key="id" :max-height="tableHeight">

      <el-table-column align="center" prop="barCode" label="条形码" min-width="120"/>
      <el-table-column fixed align="center" prop="name" label="姓名" min-width="100"/>
      <el-table-column align="center" prop="gender" label="性别" min-width="80">
        <template slot-scope="scope">{{ scope.row.gender === 1 ? '男' : scope.row.gender === 2 ? '女' :  '' }}</template>
      </el-table-column>
      <el-table-column align="center" prop="birthday" label="出生日期" min-width="120"/>
      <el-table-column align="center" prop="age" label="年龄" min-width="80"/>
      <el-table-column align="center" prop="phone" label="手机号码" min-width="120"/>
      <el-table-column align="center" prop="healthEvaluation" label="健康评价" show-overflow-tooltip min-width="120"/>
    </el-table>

    <Page :total="pageList.total" :current="pageList.currentPage" :page-size="pageList.pageSize"
          show-elevator show-sizer show-total @on-change="chagecurrent"
          :page-size-opts="[10, 30, 50, 100]"
          @on-page-size-change="chagepagesize" style="margin-top:10px;"/>

  </Content>
</template>
<script>

import {_pages} from "@/services/postScreening/errorReport.js";
export default {
  name: "errorReportList",
  props:{
    currentRowIndex:{
      type: Number,
      default:-1
    },
    taskId: {
      type: String
    },
  },
  watch:{
    currentRowIndex:{
      handler(newData, oldData) {
        if(newData && newData >= 0){

        }
      },
    },
    taskId:{
      handler(newData, oldData) {
        if(newData && this.currentRowIndex >= 0){
          this.handleDataList();
        }
      },
    },
  },
  computed: {

  },
  data() {
    return {
      tableHeight: 0,
      currentTableRowIndex: null,
      form: {
        taskId: "",
        name: "",
        barCode: "",
        phone: "",
      },
      dataList: [],
      pageList: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
    };
  },
  created(){
    this.setDynamicHeight();
    window.addEventListener('resize', this.setDynamicHeight);
  },
  mounted() {

  },
  methods: {
    setDynamicHeight() {
      const height = window.innerHeight || document.documentElement.clientHeight;
      this.tableHeight = `${height - 300}px`;
    },
    search(){
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }else if (!this.taskId) {
        this.$message.warning('请先选择需要查询的体检任务');
        return;
      }
      this.handleDataList();
    },
    handleDataList() {
      if (!this.$userSession.checkInstitutionId() || !this.taskId) {
        return;
      }
      this.form.taskId = this.taskId;

      _pages({
        ...this.form,
        ...this.pageList,
      }).then(res => {
        this.dataList = res.data.records;
        this.pageList.total = res.data.total;
      }).catch(() => {});
    },
    tableRowClassName(row, rowIndex) {
      row.row.index = row.rowIndex;
      if (this.currentTableRowIndex === row.rowIndex) {
        return "select-row";
      }else{
        return "";
      }
    },
    selectrow(e, index, event){
      this.currentTableRowIndex = e.index;
    },
    chagecurrent(e) {
      this.pageList.currentPage = e
      this.handleDataList()
    },
    chagepagesize(e) {
      this.pageList.pageSize = e
      this.handleDataList()
    },
    toInt(){
      if(this.form.barCode){
        this.form.barCode = (this.form.barCode + "").replace(/[^\d]+/g, '');
        this.form.barCode = (this.form.barCode + "").replace('.', '');
        this.form.barCode = (this.form.barCode + "").replace(/\./g, '');
        this.form.barCode = (this.form.barCode + "").replace(/\\./g, '');
        this.form.barCode = (this.form.barCode + "").replace('$#$', '');
      }
    },
    pareInt(valueName){
      if(this.form[valueName]){
        this.form[valueName] = (this.form[valueName] + "").replace(/[^\d]+/g, '');
        this.form[valueName] = (this.form[valueName]+ "").replace('.', '');
        this.form[valueName] = (this.form[valueName] + "").replace(/\./g, '');
        this.form[valueName] = (this.form[valueName] + "").replace(/\\./g, '');
        this.form[valueName] = (this.form[valueName] + "").replace('$#$', '');
      }
    }
  }
};
</script>
<style lang="postcss" scoped>
/deep/ .el-table__body tr.select-row>td.el-table__cell{background-color: #beffc5;color: #101010;}
/deep/ #searchForm .ivu-form-item {margin-bottom: 6px;vertical-align: top;zoom: 1;}
/deep/ .el-table th {background-color: #f8f8f9;font-weight: bold;}
/deep/ .el-table thead {color: #515a6e;font-weight: 500;}
.el-table{border: 0px solid #ccc;}
/deep/ .el-input__inner {height: 32px;line-height: 32px;}
/deep/ .el-input__icon{line-height: 32px;}
/deep/ .el-input--suffix .el-input__inner {padding-right: 0px;}

</style>
